var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { StringUtils } from '../../utils';
var TONE_COUNT = 4;
var getInitials = function (name) {
    return (name !== null && name !== void 0 ? name : '')
        .split(/\s+/)
        .map(function (word) { return word.replace(/[^\p{L}\p{N}]/gu, '').charAt(0); })
        .filter(Boolean)
        .slice(0, 2)
        .join('')
        .toUpperCase();
};
var getTone = function (name) {
    var seed = (name !== null && name !== void 0 ? name : '').split('').reduce(function (total, char) { return total + char.charCodeAt(0); }, 0);
    return seed % TONE_COUNT;
};
export var Avatar = function (props) {
    var initials = props.initials ? props.initials.toUpperCase() : getInitials(props.name);
    return (_jsx("span", __assign({ className: StringUtils.combineStrings([
            'localina-avatar',
            "tone-".concat(getTone(props.name)),
            props.size,
            props.extraClassName,
        ]), "aria-hidden": "true" }, { children: initials })));
};
